import React from 'react'
import Layout from 'components/layout'
import CreateAccountNew from "components/userAccount/CreateAccountNew";

function Index() {
  return (
    <Layout>
      <CreateAccountNew />
    </Layout>
  );
}

export default Index